import CartMessage from "./cart/CartMessage";

export enum BootstrapStatus {
    'IDLE' = 'IDLE',
    'LOADING' = 'LOADING',
    'LOADED' = 'LOADED'
}

export default interface AppState {
    isLoading: boolean;
    bootstrapStatus: BootstrapStatus;
    messages: CartMessage[];
}
